export const B2B_INVITE_QUERY_PARAM = 'b2bInvite';
export const B2B_INVITE_ORDERS_PATH = '/orders';

export function isB2bInviteForceParam(search: string): boolean {
  return new URLSearchParams(search).get(B2B_INVITE_QUERY_PARAM) === '1';
}

export function isB2bInviteOrdersPath(pathname: string): boolean {
  return pathname === B2B_INVITE_ORDERS_PATH;
}

export function isoWeekNumber(date: Date): number {
  const utc = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  const dayNum = utc.getUTCDay() || 7;
  utc.setUTCDate(utc.getUTCDate() + 4 - dayNum);
  const yearStart = new Date(Date.UTC(utc.getUTCFullYear(), 0, 1));
  return Math.ceil(((utc.getTime() - yearStart.getTime()) / 86400000 + 1) / 7);
}

export function pickB2bInviteCreative<T>(creatives: readonly T[], date = new Date()): T {
  if (creatives.length === 0) {
    throw new Error('B2B invite creatives list is empty');
  }
  return creatives[isoWeekNumber(date) % creatives.length];
}

type EligibilityGate = {
  isLoggedIn: boolean;
  isConfigurationLoaded: boolean;
  force: boolean;
  onOrdersPage: boolean;
  cooldownAllowsShow: boolean;
};

export function shouldForceShowB2bInvite(gate: EligibilityGate): boolean {
  return gate.isLoggedIn && gate.force && gate.onOrdersPage;
}

export function shouldFetchB2bInviteEligibility(gate: EligibilityGate): boolean {
  if (!gate.isLoggedIn || !gate.isConfigurationLoaded) return false;
  if (!gate.onOrdersPage) return false;
  if (gate.force) return false;
  return gate.cooldownAllowsShow;
}
